module.exports = __webpack_public_path__ + "img/carrousel-mov-digi-2.fd8ec20c.png";